import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faClose} from '@fortawesome/free-solid-svg-icons/faClose';
import {OUTGOING_ACTION, snippetService} from '../../services/snippet.service';
import {getClientDisplayName} from '../../services/settings.service';
import {logIconButtonClick} from '../../services/analytics.service';
import {ICON_BUTTON_CLICK_TARGET} from '../../models/cta.model';

const Header = () => {
    const clientDisplayName = getClientDisplayName();

    const close = (): void => {
        snippetService.sendMessage({action: OUTGOING_ACTION.HIDE});
        logIconButtonClick(ICON_BUTTON_CLICK_TARGET.CLOSE);
    };

    return (
            <div className="border border-primary bg-primary flex items-center text-white rounded-t py-[4px] pl-[16px] pr-[4px]">
                <div className="grow">
                    <div className="font-medium">{clientDisplayName}</div>
                </div>
                <button type="button"
                        className="w-10 h-10 flex-none font-bold rounded-full my-1 cursor-pointer"
                        onClick={close}>
                    <FontAwesomeIcon icon={faClose} size="lg"/>
                </button>
            </div>
    );
};

export default Header;
